export default "__VITE_ASSET__BdqaUtzj__"